export default function removeAllSelection() {
  const { getSelection } = window;

  if (getSelection) {
    getSelection().removeAllRanges();
  }
}
